import { usePledgeBonusPercentageQuery } from '../data-access/queries';

export const useWCPledgeBonusPercentage = () => {
	const { data } = usePledgeBonusPercentageQuery();

	const rawPercentage = data?.apr;
	const formattedBonusPercentage = !rawPercentage ? '--' : parseFloat(rawPercentage).toFixed(0);

	return { formattedBonusPercentage, rawPercentage };
};
